// extracted by mini-css-extract-plugin
export default {"thumbnail":"cUBB2g2He2wE-X24sOsUJg==","fallback":"NDydEEBP8seKpregLIOiRA=="};